import React from 'react';
import { Notice } from '../ui/Notice.js';
import { Button } from '../ui/Button.js';
import { TAB_EDIT_COPY } from '../../utils/tabEdits.js';
import { toPersianDigits } from '../../utils/timeUtils.js';

export interface SuggestModeNoticesProps {
  mode: 'direct' | 'suggest' | 'none';
  hasOwnPending?: boolean;
  adminPendingCount?: number;
  adminOffline?: boolean;
  onNavigateToEditsQueue?: () => void;
  className?: string;
  'data-testid'?: string;
}

export const SuggestModeNotices: React.FC<SuggestModeNoticesProps> = ({
  mode,
  hasOwnPending = false,
  adminPendingCount,
  adminOffline = false,
  onNavigateToEditsQueue,
  className = '',
  'data-testid': dataTestId
}) => {
  const isSuggest = mode === 'suggest';
  const showAdminNote = typeof adminPendingCount === 'number' && adminPendingCount > 0;

  if (!isSuggest && !showAdminNote && !adminOffline) {
    return null;
  }

  return (
    <div className={`flex flex-col gap-2.5 ${className}`} data-testid={dataTestId}>
      {/* C-10 info strip in suggest mode */}
      {isSuggest && (
        <Notice tone="info" testId="edit-suggest-note">
          {TAB_EDIT_COPY.c10}
        </Notice>
      )}

      {/* C-12 warning if replacing own pending */}
      {isSuggest && hasOwnPending && (
        <Notice tone="warning" testId="edit-replace-warning">
          {TAB_EDIT_COPY.c12}
        </Notice>
      )}

      {/* OQ-12 admin notice if pending suggestions exist */}
      {showAdminNote && (
        <Notice
          tone="neutral"
          testId="edit-admin-pending-note"
          action={
            onNavigateToEditsQueue ? (
              <Button size="sm" variant="ghost" onClick={onNavigateToEditsQueue}>
                صف ویرایش‌ها
              </Button>
            ) : undefined
          }
        >
          {`${toPersianDigits(adminPendingCount)} پیشنهاد در انتظار برای این بخش وجود دارد.`}
        </Notice>
      )}

      {/* C-05 admin offline note */}
      {adminOffline && (
        <Notice tone="neutral" testId="edit-offline-note">
          {TAB_EDIT_COPY.c05}
        </Notice>
      )}
    </div>
  );
};

SuggestModeNotices.displayName = 'SuggestModeNotices';
